import { useTranslation } from 'react-i18next'

import { Trash16 } from '@makyoapp/makyo-icon/icon'

import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

export const DeleteTable = () => {
  const { t } = useTranslation()
  const { setTableToRemove, table } = useGridV2Context()
  return (
    <>
      <button
        onClick={() => {
          setTableToRemove(table)
        }}
        className='mk-ddi flex-c red mk-dd-row'
      >
        <Trash16 />
        <div>
          {table?.isSnapshot ? t('Delete Snapshot') : table?.isQuery ? t('Delete Query') : t('Delete Table')}
        </div>
      </button>
    </>
  )
}
